// extracted by mini-css-extract-plugin
export default {"listItem":"styles_listItem__qjMfa","itemTitle":"styles_itemTitle__fF-fd","itemPrice":"styles_itemPrice__Ol2oF"};